import { Component, Input } from '@angular/core';
import { Asset } from '../../../common/generated-types';

@Component({
  selector: 'vsf-store-logo',
  templateUrl: './store-logo.component.html',
  styleUrls: ['./store-logo.component.scss']
})
export class StoreLogoComponent {
  @Input() normalLogo: Asset | null;
  @Input() nameLogo: Asset | null;
  @Input() smallLogo: Asset | null;
  @Input() name: string;
  @Input() path: string;
  @Input() logoHeight: string = '50px';
  @Input() displayName: boolean;
  @Input() isMobile: boolean;
  readonly NAMELOGO_HEIGHT_PX = 22;
  getDisplayWidthPx(img: Asset | null, targetH: number | null): number | null {
    if (!img || !targetH || !img.width || !img.height) return null;
    return Math.round(targetH * (img.width / img.height));
  }
}
